import { render } from "./BillingContact.vue?vue&type=template&id=cc23302c&lang=pug"
import script from "./BillingContact.vue?vue&type=script&lang=js"
export * from "./BillingContact.vue?vue&type=script&lang=js"

import "./BillingContact.vue?vue&type=style&index=0&id=cc23302c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__